import { makeStyles } from '@material-ui/styles';

import { neutral, orange, yellow } from 'shared/styles/colors';

export default makeStyles({
  container: {
    border: `1px solid ${neutral[20]}`,
    borderRadius: '0.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
  },
  header: {
    cursor: 'pointer',
    userSelect: 'none',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.5rem 0.75rem 0',
  },
  headerText: {
    fontSize: '0.625rem',
    fontWeight: 600,
    color: neutral[80],
    letterSpacing: '1.2px',
    textTransform: 'uppercase',
  },
  expandIcon: {
    transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1)',
    color: neutral[100],
    fontSize: '1rem',
    '[data-is-expanded="true"] &': {
      transform: 'rotate(180deg)',
    },
  },
  collapseContainer: {
    overflow: 'hidden',
    transition: 'height 300ms cubic-bezier(0.4, 0, 0.2, 1)',
  },
  content: {
    padding: '0 0.75rem 0.5rem',
    '& dl': {
      color: neutral[80],
      fontSize: '0.75rem',
      fontWeight: 500,
      '& dt': {
        display: 'inline',
        '&::after': {
          content: '": "',
        },
      },
      '& dd': {
        display: 'inline',
        '&::after': {
          content: '""',
          display: 'block',
        },
      },
    },
  },
  billAlert: {
    marginBottom: '0.5rem',
    padding: '0.5rem 0.75rem',
    borderRadius: '0.25rem',
    color: orange['80'],
    backgroundColor: yellow['10'],
    display: 'flex',
    gap: '0.5rem',
  },
  alertIcon: {
    fontSize: '1.2rem',
    flexShrink: 0,
    marginRight: '0.25rem',
  },
  alertMessage: {
    fontSize: '0.75rem',
    lineHeight: '1rem',
  },
});
